export default {
    tower: {
        activeCommands: "Comandos Activos",
        altCertUrl: "URL de certificado alternativa",
        metricsNav: "Métricas",
        netConfig: "Configuración de Red",
        id: 'ID',
        bank:"Nombre del banco",
        baseStations: 'Estaciones Base',
        baseStation: 'Estacion Base',
        selectedBaseStations: "Estaciones base seleccionadas",
        baseStationDetails: 'Detalles de la Estación Base',
        baseStationId: 'ID de Estación Base',
        baselineUplinkMessageAverage: "Promedio de mensajes de enlace ascendente",
        baselineUplinkMessageStdDev:"Desviación estándar de mensajes de enlace ascendente",
        baselineUplinkMessageStartTime: "Hora de inicio promedio de referencia",
        baselineUplinkAverageReset: "Restablecer el tiempo de inicio promedio de la línea base del enlace ascendente",
        lastHourUplinkMessageAverage:"Promedio de mensajes de enlace ascendente de la última hora",
        lastHourUplinkAverageHasZeros:"Al menos un intervalo de 15 minutos en la última hora no tuvo mensajes de enlace ascendente",
        disconnectTxt: "Razón desconocida",
        cmdDisabled: "El procesamiento de comandos para las estaciones base está deshabilitado",
        cmdEnabled: "El procesamiento de comandos para estaciones base está habilitado",
        seriesFrequency: 'Frec',
        general: 'General',
        timestamps: 'Marcas de Diempo',
        commsSection: 'Opciones de comunicación',
        onBattery: "En la batería",
        gpsOk: 'GPS OK',
        gpsFix: 'GPS Fijo',
        confirm:"Confirmar",
        satelliteCount: 'Recuento de Satélites',
        timeZone: 'Zona Horaria',
        location: 'Ubicación',
        latitude: 'Latitud',
        longitude: 'Longitud',
        altitude: 'Altitud (metros)',
        address: 'Dirección',
        name: 'Nombre',
        enableRouting: 'Habilitar el enrutamiento RNI',
        disableRouting: 'Deshabilitar el enrutamiento RNI',
        changeRoutingError: 'Error al habilitar / deshabilitar el enrutamiento RNI',
        routingEnabled: "Comando de enrutamiento habilitado enviado a las Estación base",
        routingDisabled: "Enrutamiento comando deshabilitado enviado a Estación base",
        description: 'Descripción',
        andorianVersion: 'Andorian Versión',
        enclosureType: 'Tipo de Cerramiento',
        transceiverType: 'Tipo de Transceptor',
        softwareVersion: 'Software Versión',
        rniStatus: 'Estado de RNI',
        rniStatusValues: {ONLINE: 'En Línea', null: 'Desconocida', OFFLINE: 'Desconectada'},
        rniRoutingEnabled: 'Enrutamiento RNI habilitado',
        softwareVersionHeader: 'Software Versión',
        softwareType: 'Cosecha de Software',
        powerMonitorType: 'Tipo de Monitor de Potencia',
        powerMonitorVersion: 'Cosecha de Monitor de Potencia',
        transmitMode: 'Modo de Transmisión',
        kFactor: 'K-Factor',
        transmitSlot: 'Ranura de Transmisión',
        ifNotRandom: '(si no al azar)',
        momCommEnabled: 'MOM Comm Habilitada',
        momCommSent: 'MOM Comm Expedida',
        commandRatio: 'Ratio de Comando',
        radioSingleRoutesCount: 'Rutas diarias de enlace ascendente único (ayer)',
        radioSingleRoutesCountSPR: 'Rutas diarias de enlace ascendente único',
        radioAllRoutesCount: 'Todas las rutas de enlace ascendente diarias (ayer)',
        radioAllRoutesCountSPR: 'Todas las rutas de enlace ascendente diarias',
        latlong: 'Lat/Long',
        alarmCount: 'Recuento de Alarmas',
        alarms: 'Alarmas activas',
        alarmsActiveTotal: 'Total de alarmas activas',
        alarmsActiveSuppressed: 'Alarmas activas suprimidas',
        alarmsActiveUnsuppressed: 'Alarmas activas no suprimidas',
        city: 'Ciudad',
        state: 'Estado',
        zipCode: 'Código Postal',
        postalCode: 'Código postal',
        defaultPowerAttenuation: "Atenuación de potencia planificada dB",
        configuredPowerAttenuation: "Atenuación de potencia configurada dB",
        zip: 'Postal',
        createTower: 'Crear Estación Base',
        lastHeard: 'Último Oído',
        lastHeardMOA: 'Último oído (en el aire)',
        lastHeardMOATitle: 'Último mensaje recibido desde cualquier punto final asociado con este cliente',
        lastHeardMOAMinutes: 'Últimos minutos escuchados (al aire)',
        lastHeardMOAHours: 'Últimas horas escuchadas (en el aire)',
        lastHeardNonMOA: 'Último oído (no en el aire)',
        lastUplinkMessageReceived: 'Último mensaje de enlace ascendente recibido',
        lastUplinkMessageReceivedTitle: 'Último recuento de mensajes de enlace ascendente distinto de cero informado por esta estación base entre todos los clientes asociados',
        firstHeard: 'Escuchado por Primera Vez',
        firstHeardRni: 'Escuchado por Primera Vez por RNI',
        discovered: "Descubierta",
        lastConfigChange: 'Último Cambio de Configuración',
        lastTgbProgsRestart: 'Último Reinicio de la Aplicación',
        lastMetadataUpdate:"Última fecha de actualización de metadatos",
        ntpMaximumError: 'Error máximo de NTP',
        bitrate:"Tasa de bits de transmisión horaria",
        bitrates:{
            0 : "mPass de 5 kbps",
            1 : "mPass2 de 10 kbps",
            2 : "Tanto mPass de 5 kbps como de 10 kbps en dos transmisiones",
            3 : "10 kbps 4GFSK m4Pass",
            4 : "20 kbps 4GFSK m4Pass2",
        },
        broadcastType: "Tipo de transmisión horaria",
        broadcastTypes:{
            1 : "Transmisión horaria de FNV1",
            2 : "Transmisión del tiempo de respuesta de la encuesta FNV2 FlexType 4",
            3 : "Transmisión de 1 hora FNV2 FlexType",
            4 : "Intervalo variable de FNV1 MoMComm",
        },
        broadcastInterval:"Intervalo de sincronización horaria",
        lastTransmit: 'Informe de última transmisión',
        lastEnqueueReport: "Último informe de puesta en cola",
        lastQueueReport: "Último informe de cola",
        lastConfigRetrieval: "Recuperación de la última configuración",
        updateTower: 'Actualizar Estación Base',
        deleteTower: 'Eliminar Estación Base',
        deleteTowerPrompt: '¿Está seguro de que desea eliminar la estación base {baseStationName}?',
        deleteTowerError: 'Error al eliminar la estación base {baseStationId}',
        disconnected:"Desconectado",
        close:"Cerca",
        reload:"Reconectar",
        getManifestError: "Error al obtener el manifiesto {baseStationId}",
        towerDeleted: 'La estación base {baseStationId} se eliminó correctamente',
        cancelRebootAlert:"Cancelar Reinicio",
        transmitChannels: 'Canales de Transmisión',
        receiveChannels: 'Recibir Canales',
        slotInformation: 'Información de la Ranura',
        unified: 'Unified',
        frequencyNumber: 'Frecuencia #',
        frequency: 'Frecuencia (MHz)',
        width: 'Anchura (kHz)',
        lastUsed: 'Utilizado por Ultima Vez',
        averageNoise: 'Ruido medio',
        averageSignal: 'Señal media',
        nmsAverageNoise: 'NMS Ruido promedio',
        nmsAverageSignal: 'Señal promedio de NMS',
        hardwareId: 'ID del Hardware',
        hardwareChainNumber: 'Cadena de Hardware #',
        receiverNumber: 'Receptor #',
        channelAttributes: {
            title: 'Atributos',
            tooltips: {
                primary: 'Primario',
                secondary: 'Secundario',
                admin: 'Admin',
                buddy: 'compañero',
                fwdl: 'Descarga de Firmware',
                install: 'Instalar'
            }
        },        
        modulation: 'Modulación',
        modulationsPlanned: 'Modulaciones planificadas',
        slot: 'Espacio',
        centerFrequency: 'Frecuencia Central (MHz)',
        channelWidth: 'Ancho de banda (kHz)',
        demodulatorType: 'Tipo de Demodulador',
        createDate: 'Creado',
        bestTuningUplinkCount: 'Mejor recuento de enlaces ascendentes de sintonización',
        clickToDisplayBestTuningUplink: 'Haga clic para ver las radios que tienen esta estación base como su mejor enlace ascendente de sintonización',
        clickToDisplayDetails: 'Haga clic para mostrar los detalles de la estación base',
        clickToDisplayRadiosSingle: 'Haga clic para mostrar las radios que tienen una única ruta a esta Estación base',
        clickToDisplayRadiosAll: 'Haga clic para mostrar las radios que tienen una ruta a esta Estación base',
        sets: 'Conjuntos',
        setCreated: 'Establecer \'{name}\' creado con éxito',
        setDeleted: 'Establecer \'{name}\' eliminado exitosamente',
        setUpdated: 'Establecer \'{name}\' actualizado exitosamente',
        stales: "Pasados",
        staleMinutes: "Momentos de umbral 5 - 60",
        staleHours: "Horas de umbral 1 - 999",
        towerConfig: 'Configuración de la estación base',
        ipAddress: 'Dirección IP',
        sshPort: "SSH Port",
        networkPlanConfigStatus: 'Estado de configuración del plan de red',
        configCommandStatus: 'Estado del comando de configuración',
        configCommandDate: 'Último cambio de configuración enviado',
        networkPlanConfigDate: 'Fecha de configuración del plan de red',
        deploymentStatus: 'Estado de Despliegue del Plan de Red',
        deploymentDate: 'Fecha de Despliegue del Plan de Red',        
        planned: 'Planeado',
        messages: 'Mensajes',
        selectTowerDialog: {
            title: 'Seleccione una estación base',
            btn: 'Seleccionar'
        },
        networkPlan: {
            label: 'Plan de Red',
            upload: {
                label: 'Subir Plan de Red',
                initialMessages: 'Por favor, seleccione archivos para cargar.',
            },
            deploy: {
                label: "Desplegar Plan de Red",
                all: "Desplegar Plan de Red en Todos",
                set: "Desplegar Plan de Red en Conjunto",
                selected: "Desplegar Plan de Red en Seleccionados",
                config: {
                    hint: "La configuración a fusionarse con el Plan de Red al desplegar."
                }
            },
            lastUploaded: "Última Subida del Plan de Red",
            noLastImport: "No hay plan de red disponible",
            channelConfig: 'Seleccionar Archivo de Configuración de Canal',
            siteList: 'Seleccionar Archivo de Lista de Sitios',
        },           
        selectFiles: 'Seleccione los archivos para cargar.',
        deployConfigToSelected: 'Implementar configuración en seleccionados',
        deployConfigToAll: 'Implementar configuración en todos',
        setSecurityOnSelected: 'Autenticar Estación base',
        uploadSuccess: 'Subido correctamente.',
        uploadFailure: '¡Errores encontrados! No se implementaron cambios. ',
        uploadInProgress: 'Subida en curso.',
        lastUploaded: 'Última subida',
        deployTowers: 'Implementar Estación base',
        deployTowersAll: 'Implementar en todas las estaciones base',
        selectConfigToDeploy: 'Seleccionar configuración para implementar',
        selectVersion: 'Seleccione la versión para implementar',
        protocol:"Seleccione el protocolo preferido",
        selectConfig: 'Seleccionar configuración para implementar',
        globalConfig: 'Configuración global',
        lastKnownConfig: 'Última configuración conocida',
        userId: 'ID de usuario',
        deploySuccess: "El comando de despliegue del Plan de Red se ha encolado exitosamente para la(s) estación(es) base seleccionada(s). Puede monitorear el estado en Comandos Activos o en el historial de cada estación base.",
        deployInProgress: "Despliegue del Plan de Red en proceso...",
        deployFailure: "El comando de despliegue del Plan de Red ha fallado.",
        password: 'Contraseña',
        securityInProgress: 'Solicitud de configuración de seguridad en curso.',
        securitySuccess: 'Configuración de seguridad en cola.',
        securityFailure: '¡Falló la configuración de seguridad!',
        secureTowers: 'Configurar autenticación de Estación base',
        securityConfigDate: 'Fecha de configuración de seguridad',
        securityConfigStatus: 'Estado de configuración de seguridad',
        notPlannedWarning: 'Advertencia: Las Estación base que están "No planificadas" se omitirán.\nHa seleccionado las siguientes Estación base con este estado: ',
        transmitter: "Transmisora",
        radioCount: "Recuento de radio",
        cpcCards: "Tarjetas CPC",
        cardNumber: "Número de tarjeta",
        tipFw: "TIP Versión de firmware",
        dsp1Fw: "DSP1 Versión de firmware",
        dsp2Fw: "DSP2 Versión de firmware",
        fpga1Fw: "FPGA1 Versión de firmware",
        fpga2Fw: "FPGA2 Versión de firmware",
        onBoardError: 'La estación base {id}, no se ha incorporado, esta acción no es válida',
        noOnboardedEror: 'No se encontraron estaciones base integradas.',
        csvColumnError:'El archivo CSV debe contener la columna ID de la estación base',
        skip: "Estaciones base omitidas debido a no válidas",
        duplicate: "Estaciones base omitidas debido a una configuración duplicada ",
        defaultSshPort:"Se omitieron las estaciones base para evitar el puerto SSH duplicado asignando un valor predeterminado",
        sshPortError:"Puerto SSH no válido {puerto}",
        download: "Descargar",
        cancel: "Cancelar",
        downloaded: "Archivo descargado",
        upload:"Subir",
        selectFile: "Seleccione Archivo",
        selectDestination: "Introducir destino",
        downloadFile: "Introduce la ruta completa",
        errDownload : "Error No tienes permiso para descargar este archivo",
        errUpload : "Error No tiene permiso para cargar un archivo en el directorio seleccionado",
        err:"Fallido",
        success: "Cargado con éxito",
        csvParseIssues: "Problemas de análisis de carga de CSV",
        csvSkippedTowers: "Estaciones base omitidas debido a falta de información",
        latest: "Última versión de software",
        booted: "Arrancado",
        lastinstalled:"Última instalación",
        fixTowerTime: "Hora correcta de la estación base",
        retrySsh: "Reintentar la conexión SSH",
        socketConnectionError: "No se pudo establecer una conexión SSH con la estación base.",
        socketConnectionHint: "Se recomienda utilizar una conexión HTTPS al utilizar el terminal.",
        ncsCommandTypesNA: {
            TOWER_PROVISION_NCS: "Aprovisionar una estación base",
            TOWER_INSTALL_SOFTWARE: "Instalar imagen en la estación base",
            TOWER_APPLY_CONFIG: "Configurar una estación base",
            TOWER_CANCEL_REBOOT: "Cancelar el reinicio de la estación base",
            TOWER_REBOOT: "Reinicio de la estación base",
            TOWER_SCHEDULE_REBOOT: "Reinicio programado de la estación base",
            TOWER_REFRESH_CERT: "Refrescar certificado para la estación base",
            TOWER_ADD: "Agregar una estación base",
            TOWER_EDIT: "Editar una estación base",
            TOWER_GET_METADATA: "Obtener metadatos para la estación base",
            TOWER_ROTATE_PASSWORD:"Contraseña de rotación de la estación base",
            TOWER_CORRECT_TIME_DRIFT: "Hora correcta de la estación base",
            TOWER_DEPLOY_NETWORK_PLAN: "Desplegar Plan de Red",
            TOWER_REONBOARD: "Estación base de reincorporación",
            TOWER_ONBOARD: "Estación base a bordo"
        },
        ncsCommandTypesArqiva:{
            TOWER_PROVISION_NCS: "Aprovisionar una estación base",
            TOWER_ROUTING_STATUS: "Estado de la Estación base de ping",
            TOWER_INSTALL_SOFTWARE: "Instalar imagen en la estación base",
            TOWER_APPLY_CONFIG: "Configurar una estación base",
            TOWER_CANCEL_REBOOT: "Cancelar el reinicio de la estación base",
            TOWER_REBOOT: "Reinicio de la estación base",
            TOWER_SCHEDULE_REBOOT: "Reinicio programado de la estación base",
            TOWER_REFRESH_CERT: "Refrescar certificado para la estación base",
            TOWER_ADD: "Agregar una estación base",
            TOWER_EDIT: "Editar una estación base",
            TOWER_GET_METADATA: "Obtener metadatos para la estación base",
            TOWER_ROTATE_PASSWORD:"Contraseña de rotación de la estación base",
            TOWER_CORRECT_TIME_DRIFT: "Hora correcta de la estación base",
            TOWER_DEPLOY_NETWORK_PLAN: "Desplegar Plan de Red",
            TOWER_REONBOARD: "Estación base de reincorporación",
            TOWER_ONBOARD: "Estación base a bordo"
        },
        config: {
            active: "Activo",
            protocolWarn:"Las conexiones https pueden recurrir a http si https no es viable",
            compareModalTitle: "Comparar configuración",
            compareModalText: "Compare configuraciones históricas de estaciones base por fecha.",
            restoreModalText: "Compare y restaure las configuraciones históricas de la estación base por fecha.",
            confirmModalTitle: "Confirmar restauración de configuración",
            confirmModalText: "Confirme su decisión de restaurar la configuración desde:",
            confirmModalUpdateText: "El esquema activo difiere de la configuración restaurada. Guarde y actualice la configuración manualmente. <br /><br /><strong>Advertencia:</strong> Esto sobrescribirá cualquier cambio de configuración no implementado en la estación base.",
            noData: "No hay datos para mostrar",
            noManifest: "No hay manifiesto disponible para el banco seleccionado",
            acTab:"Comandos Activos",
            activeConfig: "Configuración activa",
            pastConfig: "Configuración anterior",
            updatedConfig: "Configuración actualizada",
            configDate: "Fecha de configuración",
            activeConfigActions: "Acciones de configuración activa",
            deployToSet: "Implementar para configurar",
            networkPlan: "Plan de red",
            netConfig: "configuración de la red",
            deployMenu: "Implementar versión en estaciones base",
            deployImgBySelection: "Implementar versión en estaciones base seleccionadas",
            deployImgBySet: "Implementar lanzamiento por conjunto",
            updateCurrentConfigurations: "Actualizar configuración activa",
            restoreConfigurations: "Restaurar configuración",
            profiles: {
                selectProfileDialogTitle: "Seleccionar Perfil de Configuración",
                nav: "Perfiles de Configuración",
                name: "Nombre del Perfil de Configuración",
                create: "Crear Perfil de Configuración",
                edit: "Editar Perfil de Configuración",
                delete: {
                    action: "Eliminar Perfil de Configuración",
                    dialogText: "¿Estás seguro de que quieres eliminar este perfil de configuración?"
                },
                deploy: {
                    action: "Desplegar Perfil de Configuración",
                    toSelected: "Desplegar Perfil de Configuración a Seleccionados",
                    toSingle: "Desplegar Perfil de Configuración a una Estación Base",
                    toSet: "Desplegar Perfil de Configuración al Conjunto",
                    text: "¿Estás seguro de que quieres desplegar este perfil de configuración a la(s) torre(s) seleccionada(s)?",
                    singleTowerText: "¿Está seguro de que desea implementar este perfil de configuración en esta estación base?"
                },
                searchSchema: {
                    placeholder: "Buscar Esquemas",
                    hint: "Selecciona un esquema para validar en el editor JSON"
                },
                dialogDescription: "A medida que escriba JSON, se validará contra todos los esquemas disponibles. Solo el esquema seleccionado se validará en el editor de JSON.",
                errorCreate: "Error al crear el perfil de configuración.",
                errorUpdate: "Error al actualizar el perfil de configuración.",
                errorDelete: "Error al eliminar el perfil de configuración."
            },            
            restoreSaveAndUpdate: {
                title: "Guardar los cambios restaurados y actualizar manualmente antes de implementar.",
                button: "Actualizar y Restaurar",
            },
            restoreConfigValid: `Por favor, confirme su decisión de restaurar la configuración de: <strong>{date}.</strong>
                <br />
                <br />
                <ul>
                    <li><strong>Guardar y Actualizar</strong> sobrescribirá cualquier cambio no implementado con la configuración restaurada, permitiéndole modificar la configuración antes de la implementación.</li>
                    <li><strong>Implementar</strong> enviará inmediatamente la configuración restaurada a la estación base.</li>
                </ul>`,
            restoreConfigInvalid: `La configuración de <strong>{date}</strong> tiene errores de validación. No se puede implementar en la estación base tal como está.
                <br />
                <br />
                <ul>
                    <li><strong>Guardar y Actualizar</strong> guardará la configuración con errores, permitiéndole modificarlos y corregirlos antes de la implementación.</li>
                </ul>`,
            noActiveConfig: "No se puede realizar la acción porque la configuración de la estación base seleccionada no está disponible.",
            downloadActiveConfig: "Descargar configuración activa",
            exportConfig: {
                title: "Exportar la configuración completa en JSON",
                button: "Exportar"
            },
            saveAndUpdate: "Guardar y actualizar",
            restoreConfigAction: "Restaurar",
            noActiveConfigToDisplay: "La configuración activa para la estación base {id} no está disponible",
            updateSavedConfigurations: "Actualizar configuracione guardadas",
            compareConfigurations: "Comparar configuraciones",
            saveUpdateConfig: "Guardar configuraciones actualizadas",
            activeImage: "Liberación activa",
            activeBuild: "Construcción activa",
            activeSoftwareBank: "Banco de software activo",
            standByImage: "Liberación en espera",
            lastReleaseStatus: "Estado de implementación de la última versión",
            lastReleaseDate: "Fecha de implementación de la última versión",
            lastRebootDate: "Última fecha de reinicio",
            uploadImg: "Subir versión",
            importImg: "Importar imagen",
            criticallyOutOfDate: "Críticamente desactualizado",
            released: "Publicada",
            scheduleTime: "Fecha de reinicio programada",
            scheduleStatus: "Estado de reinicio programado",
            scheduleBank: "Banco de reinicio programado",
            platform: "Plataforma",
            netConfigs: "Configuraciones de red",
            manageImageVersions: "Administrar versiones de imágenes",
            editImgVers: "Editar versiones de imágenes",
            deleteImgVers: "Eliminar versiones de imágenes",
            deleteImage: '¿Está seguro de que desea eliminar la versión seleccionada?',
            deleteImagesSuccess: 'Se eliminaron las versiones seleccionadas',
            deleteImagesError: 'Error al eliminar las versiones seleccionadas',
            uploadImageSuccess: 'Los archivos de la versión se cargaron correctamente para su validación.',
            updateImageVers: "Actualizar versión seleccionada",
            version: "Versión",
            showCli:"Mostrar CLI",
            manifest:"Mostrar manifiesto",
            towerId:"Identificación de la torre",
            build:"Construir",
            filename:"Nombre del archivo",
            content:'contenido',
            successUpdateImageVers: "Actualizado exitosamente",
            errorUpdateImageVers: "Error al actualizar",
            rebootMenu: "Reiniciar estaciones base",
            rebootTowers: "Reiniciar estaciones base seleccionadas",
            rebootTowersBySet: "Reiniciar estaciones base por conjunto",
            rebootAllTowers: "Reiniciar todas las estaciones base",
            getMetaData: "Obtener metadatos",
            getMetaDataMsg: "Comando en cola exitoso para obtener metadatos de las estaciones base",
            cancelReboot: "Cancelar reiniciar",
            getMetaDataErr: "Su solicitud para obtener metadatos falló.",
            activeBank: "Banco Activo",
            standByBank: "Banco de espera",
            lastReboot: "Último reinicio",
            deployAll: "Implementar Release en todas las estaciones base",
            rebootAll: "Reiniciar todo",
            compareConfigurationsTitle: 'Comparar configuraciones',
            showChanges: "Mostrar cambios",
            noChanges: "No hay cambios para mostrar.",
            noChangesDeploy: "No hay cambios para implementar.",
            selectConfig: "Seleccione Configuración",
            failedToDeploy: "No se pudo implementar",
            failedToFetchImageVersions: "Error al obtener las versiones de la imagen",
            successfullyPlacedForDeployment: "Colocado correctamente para su implementación",
            configCommandStatusWarning: "No se puede realizar la acción porque la estación base seleccionada está en proceso de actualización de configuraciones",
            activeConfiguration: "Configuración activa",
            deployAllTowers: "Implementar en Todas Las Estaciones Base",
            deployConfirmMsg: "Si hay diferencias entre la configuración por etapas y la activa, ¿desea",
            selectedImages: "Imágenes seleccionadas",
            manageImages: "Administrar lanzamientos",
            startTime: "Hora de inicio",
            errorMessage : "Error de mensajes",
            configuration: "Configuración",
            release: "Liberar",
            deployTowerSuccess: "Colocado correctamente para su implementación",
            scheduleRebootTitle: "Establecer fecha y hora (HH:MM AM/PM) para reiniciar en el futuro",
            scheduleReboot: "Programar reinicio",
            rebootTowerSuccessMsg: "Reiniciar exitosamente en cola",
            rebootTowerFailMsg: "No se pudo reiniciar la cola",
            invalidRebootStatus:"Estado de reinicio no válido para cancelar reinicio",
            revertUpdatesTitle: "¿Está seguro de que desea revertir las actualizaciones de",
            saveChangesTitle: "¿Quieres guardar los cambios?",
            preview: {
                btn: "Ver Cambios",
                title: "Vista previa de los cambios locales"
            },
            editorBtn: {
                btn: "Ver Editor",
                title: "Ver editor de configuración"
            },
            deployChanges: {
                btn: "Desplegar",
                title: "Enviar comando a la estación base para desplegar cambios locales a la configuración activa",
            },
            saveChanges: {
                btn: "Guardar",
                title: "Guardar cambios sin enviar comando a la estación base"
            },            
            schemaGenDetails: "Detalles generales del esquema actual",
            basestationEnclosureType: "Tipo de recinto de la estación base",
            hostnameBaseStation: "Nombre de host de la estación base",
            configurationSchemaVersion: "Versión del esquema de configuración",
            timezone: "Zona horaria",
            configurationVersion: "Versión de configuración",
            revertChanges: "Revertir cambios",
            validationError: "Error de validacion",
            schemaGeneralInfo: "Información general del esquema",
            configurationsSavedSuccessMsg: "Configuraciones guardadas",
            deployingLocalChangesToBaseStation: "Implementación de cambios locales en la estación base",
            deployingLocalChangesToBaseStationFailed: "Error al implementar cambios locales en la estación base",
            saveChangesBeforeDeployError: "Error al guardar los cambios de configuración. Implementación cancelada.",
            failedSaveConfigurations: "Configuraciones guardadas fallidas",
            undoStaged: "Deshacer por etapas",
            merge: "Unir",
            uploadInProgress: "Carga en curso",
            imageVerificationInProgress: "Verificación de imagen en curso",
            imageVerificationFailed: "Verificación de imagen fallida",
            uploadCancelled: "Carga cancelada",
            uploaded: "subido",
            closeUploadDialogTitle: "Cancelar todas las cargas y cerrar el cuadro de diálogo",
            importFileSuccess: "Archivo importado correctamente",
            editConfigTitle: "Continuar editando cambios locales",
            activeConfigErrors: "Errores de configuración activa",
            newActiveConfigErrors: "Nuevos errores de configuración activa",
            savedConfigErrors: "Saved Configuration Errors",
            savedConfigErrorsDescription: "The data in the saved configuration is no longer valid for the current schema and will be removed on the next save or deploy.",
            preexistingActiveConfigErrors: "Errores de configuración activos preexistentes",
            noPreexistingActiveConfigErrors: "Sin errores de configuración activos preexistentes",
            onboard: {
                action: "Embarcar estación(es) base",
                single: "Embarcar/Editar una estación base",
                selected: "Embarcar estación(es) base seleccionada(s)",
                reonboardSingle: "Volver a incorporar Estación Base",
                set: {
                    action: "Incorporar Estaciones Base por Conjunto",
                    successMsg: "Incorporación en cola para el conjunto seleccionado exitosa.",
                    errorMsg: "Error al poner en cola la incorporación para el conjunto seleccionado."
                },                
                csv: "Embarcar estaciones base mediante archivo CSV",
                reonboard: "Re-Embarcar Estación Base",

            },
            updateTower: {
                confirm: {
                    title: 'Confirmar Acción en la Estación Base',
                    msg: 'Esta acción eliminará cualquier configuración pendiente en la estación base. ¿Desea continuar?'
                }
            },     
            updateCerts: "Actualizar certificaciones de estaciones base",
            addTowerAction: "Las estaciones base seleccionadas agregan comandos enviados",
            addTowerActionError: "La adición de las estaciones base seleccionadas falló",
            updateTowerAction: "Comandos de actualización de estaciones base seleccionadas enviados",
            updateTowerActionError: "La actualización de las estaciones base seleccionadas falló",
            updateTowerActionWarning: "La actualización de las estaciones base seleccionadas falló",
            updateTowerDlogTitle: "Editar estación base",
            addTowerDlogTitle: "Agregar una estación base",
            showJSONEditor: "Mostrar editor JSON",
            showFormEditor: "Mostrar editor de formularios",
            activeConfigErrorDescription: "Estos son los errores de configuración activa y preexistente de la estación base",
            information: "Información general",
            missingIpAddress: "La estación base debe tener una dirección IP",
            noActiveRelease: "No se encontró una versión activa en la estación base",
            readOnlyMessage: "No tienes permisos para modificar una propiedad de solo lectura",
            rotateAdminPswd: "Rotar contraseña tmadmin",
            showAdminPswd: "Mostrar contraseña tmadmin",
            failedReonboardBts: "Su solicitud de incorporación de la estación base ha fallado.",
            successReonboardBts: "Su solicitud de incorporación de la estación base se ha puesto en cola con éxito. Se enviará a la(s) estación(es) base seleccionada(s) en breve.",
            rotateAdminPswdRequestSent: "Envío de solicitud de rotación tmadmin a estaciones base seleccionadas",
            rotateAdminPswdRequestErr: "Error en la solicitud de rotación tmadmin",
            showAdminPswdRequestErr: "Error al mostrar la contraseña tmadmin",
            tmAdminPswd: "La contraseña de tmadmin es: ",
            tmAdminPolicy:"La política de rotación de tmadmin es: ",
            tmAdminTitle: "Información de tmadmin",
            noAdminPswdResult: "Sin contraseña tmadmin establecida",
            schemaVersionMismatch: "El esquema activo no es compatible con la configuración anterior.",
            editor: {
                readOnlyLint: "Nota: esta opción es de sólo lectura.",
                redactedLint: "Nota: permiso insuficiente para ver esta opción.",
                statusParseError: "Error de sintaxis JSON - ¡La configuración no se guardará!",
                statusSchemaError: "Error de Validación",
                statusReadOnly: "Sólo Lectura",
                cmControlCharacter: "Carácter de Control",
                cmSelectionDeleted: "Selección Eliminada",
                cmFoldedLines: "Plegó las Líneas",
                cmUnfoldedLines: "Desplegó las Líneas",
                cmTo: "a",
                cmFoldedCode: "Código Plegado",
                cmUnfold: "desplegar",
                cmFoldLine: "Plegar la línea",
                cmUnfoldLine: "Desplegar la línea",
                cmGoToLine: "Ir a la línea",
                cmGo: "ir",
                cmFind: "Encontrar",
                cmReplace: "Reemplazar",
                cmNext: "siguiente",
                cmPrevious: "anterior",
                cmAll: "todo",
                cmMatchCase: "coincidir mayúsculas y minúsculas",
                cmByWord: "por palabra",
                cmReplaceLower: "reemplazar",
                cmReplaceAll: "reemplazar todo",
                cmClose: "cerrar",
                cmCurrentMatch: "coincidencia actual",
                cmReplacedMatches: "reemplazaron a $ coincidencias.",
                cmReplacedMatchOn: "reemplazó coincidencia en la línea $",
                cmOnLine: "en la línea",
                cmCompletions: "Terminaciones",
                cmDiagnostics: "Diagnósticos",
                cmNoDiagnostics: "No hay diagnósticos"
            },
            outOfBandWarning: "La configuración de la torre ha cambiado desde la última búsqueda. Revisa la diferencia actualizada."
        },
        db: {
            CLI: "Terminal de estación base",
            ActiveAlarms: 'Alarmas activas',
            commandInCounts: 'Entrantes Comando Cuenta',
            CommandIn: 'Entrantes Comando Cuenta para el',
            Transmit: 'Enlace Downlink Comandos Enviados',
            receiveCounts: 'Mensajes Uplink Recibidos',
            commandInCountsTitle: 'Enlace Downlink Comandos Recibidos',
            CommandOut: 'Enlace Downlink Comandos En Cola',
            ackCounts: 'Recuentos de Mensajes Ack',
            ackCountsTitle: 'Ack Cuenta para el',
            ackType: 'Tipo de Ack',
            TowerAck: 'Mensajes Ack',
            dupBuddyMsgCounts: 'Recuento Mensajes Amigos Dup',
            dupBuddyMsgCountsTitle: 'Recuento Mensajes Amigos Duplicados para el',
            AllOut: 'Completamente',
            BuddyDuplicate: 'Mensajes Amigos Dup',
            BaseStationIdRange: 'Rango de ID',
            RadiosHeardByTower: 'Radios directas escuchadas',
            RadiosHeardByTowerPercentChange: 'Radios escuchadas % de cambio',
            radiosHeardByTowerDistance: 'Distancia de las radios a la mejor Estación base',
            SingleRouteRadiosByTower:'Rutas de enlace ascendente únicas diarias',
            SingleRouteRadiosByTowerGraphLabel: 'Enlace ascendente de conteo de radio',
            uniqueBuddyMsgCounts: 'Recuento Mensajes Amigos Unic',
            uniqueBuddyMsgCountsTitle: 'Recuento Mensajes Amigos Unicos para el',
            BuddyUnique: 'Mensajes Amigos Unicos',
            transmitCounts: 'Recuentos de Mensajes Downlink',
            transmitCountsTitle: 'Downlink Cuenta para el',
            transmitShort: 'Mensajes Downlink',
            receiveCountsTitle: 'Uplink Cuenta para el',
            CPC: 'Mensajes Uplink Recibidos',
            CPCShort: 'Mensajes Uplink',
            uplinkMessages: 'Mensajes Uplink',
            uplinkMessagesGraphLabel: 'Contar',
            commandOutCounts: 'Salida Comando Cuenta',
            commandOutCountsTitle: 'Salida Comando Cuenta para el',
            commsHubDownlinkMsgs: 'Comandos de enlace descendente de CommsHub en cola',
            commsHubDownlinkMsgsGraphLabel: 'Contar',
            commsHubUplinkMsgs: 'Mensajes de enlace ascendente de CommsHub',
            commsHubUplinkMsgsGraphLabel: 'Contar',
            commsHubPingCommands: 'Pings de enlace descendente de CommsHub',
            commsHubPingCommandsGraphLabel: 'Contar',
            commsHubUplinkMsgsAndIdleNoise: 'Mensajes de CommsHub y ruido de inactividad promedio',
            UplinkMessagesByCustomer: 'Mensajes de Enlace Ascendente Recibidos por el Cliente',
            UplinkMessagesByCustomerGraphLabel: 'Contar',
            UplinkTrafficTrends: 'Tendencias del tráfico de enlaces ascendentes',
            downlinkMessages: 'Mensajes de Enlace Descendente',
            downlinkMessagesGraphLabel: 'Contar',
            idleNoiseShort: 'Ruido Ocioso',
            highestAvgIdleNoise: 'Ruido de inactividad promedio más alto',
            btsIdleNoise: 'Ruido inactivo informado por la estación base (promedio)',
            btsIdleNoiseGraphLabel: 'dB',
            IdleNoiseTitle: 'Ruido Medio Ocioso para el',
            IdleNoiseGraphLabel: 'dB',
            idleNoiseSysAvg: 'Ruido Medio Ocioso - Promedio Sistema',
            DataNoise: 'Ruido inactivo de terminales recibidos (promedio)',
            DataNoiseGraphLabel: 'dB',
            tuningNoise: "Ruido de sintonización",
            DataSignal: 'Señal de terminales recibida (promedio)',
            DataSignalGraphLabel: 'dB',
            radiosHeardGraphLabel: 'percent',
            baseStationLag: 'Retraso Promedio de la Estación Base',
            BaseStationLag: 'Retraso Promedio de la Estación Base',
            baseStationLagTitle: 'Retraso Promedio de la Estación Base para',
            baseStationLagGraphLabel: 'ms retraso',
            lag: 'Retraso',
            baseStationCounts: 'Cuenta Base Estación',
            baseStationCountsAndAlarms: 'Recuentos y Alarmas de la Estación Base',
            baseStationCountsGraphLabel: 'Contar',
            baseStationCountsAndAlarmsGraphLabel: 'Contar',
            baseStationCountsTitle: 'Cuenta Base Estación para el',
            currentRadioCount: 'Conteo Actual de Radios',
            targetRadioCount: 'Conteo Objetivo de Radios',
            loadDifference: 'Diferencia (Objetivo - Actual)',
            ForwardPower: 'Energía Delantera',
            ReflectedPower: 'Energía Reflejada',
            vswr: 'VSWR',
            VSWR: 'VSWR',
            vswrTitle: 'VSWR Medio para el',
            vswrGraphLabel: 'VSWR',
            powerGraphLabel: 'energía (dB)',
            appMessages: 'Mensajes de Aplicación',
            commands: 'Comandos Enviados',
            pings: 'Comandos de Ping',
            PingCommands: 'Comandos de Ping',
            PingCommandsGraphLabel: 'Contar',
            PingResponses: 'Respuestas de Ping',
            PingResponsesGraphLabel: 'Contar',
            cmdPriority: 'Prioridades de Comando',
            commandPriorities: 'Prioridades de Comando',
            commandPrioritiesGraphLabel: 'Contar',
            appMessagesTitle: 'Mensajes de Aplicación Recibidos',
            commandsTitle: 'Comandos Enviados',
            pingCommandsTitle: 'Comandos de Ping Enviados',
            pingResponsesTitle: 'Respuestas de Ping Recibidos',
            cmdPriorityTitle: 'Prioridades de Comando',
            graphError: 'Error al recuperar los datos del gráfico para {graphName}',
            channelStats: 'Estadísticas del Canal',
            channelStatsGraphLabel: 'Contar',
            modulation: 'Modulación',
            demodulatorType: 'Tipo de Demodulador',
            systemAverage: 'Promedio Sistema',
            systemTotal: 'Total del Sistema',
            allChannels: 'Todos los Canales',
            radiosHeard: 'Radios directas escuchadas',
            baseStationQueueDepthTitle: 'Profundidad de Cola',
            baseStationTotalQueueDepthTitle: 'Profundidad Total de la Cola',
            queueDepths: 'Profundidades de Cola',
            queueDepthsGraphLabel: 'Mensajes promedio',
            vswrAndMsgCounts: 'Mensajes de estación base y VSWR',
            vswrAndMsgCountsGraphLabel: 'Contar',
            Temperature: 'Temperatura',
            TemperatureGraphLabel: 'Temperatura (°C)',
            TowerAckDetail: 'Recs de la Estación base',
            TowerAckDetailGraphLabel: 'Contar',
            radiosTransmitted: 'Transmisión directa a radios',
            RadiosTransmittedByTowerPercentChange: 'Cambio de porcentaje de radios transmitidas (caída reciente más grande))',
            RadiosTransmittedPercentChange: 'Cambio de porcentaje de radios transmitidas',
            RadiosTransmittedByTowerPercentChangeCol: 'Cambio de porcentaje de radios transmitidas',
            RadiosTransmittedByTowerPercentChangeGraphLabel: 'Por ciento',
            Uptime: 'Tiempo de actividad',
            fec: 'CEHA',
            AirTime: "Tiempo en Antena",
            AirTimeGraphLabel: "Segundos",
            ChannelThroughput: "Rendimiento del Canal",
            AirTimeByCustomer: "Tiempo en Antena por el Cliente",
            AirTimeByCustomerGraphLabel: "Segundos",
            ChannelThroughputByCustomer: "Rendimiento del Canal por el Cliente"
        },
        distanceToTower: {
            UNKNOWN: 'Desconocida',
            LESS_THAN_ONE_MILE: '< 1 milla',
            ONE_MILE_TO_LESS_THEN_THREE_MILES: '>= 1 milla and < 3 millas',
            THREE_MILES_TO_LESS_THEN_FIVE_MILES: '>= 3 millas and < 5 millas',
            FIVE_MILES_OR_MORE: '>= 5 millas'
        },
        staleFilters: {
            Hour1: "1 Hora",
            Hour4: "4 Horas",
            Hour12: "12 Horas",
            Day1Plus: "1+ Dias"
        },
        errors: {
            retrieveDetails: 'Error al recuperar los detalles de la Estacion Base para la ID de la Estacion Base {baseStationId}',
            createSetMaxIds: 'Demasiadas estaciones base seleccionadas. Se puede seleccionar un máximo de {cnt} estaciones base al crear un conjunto',
            addtoSetMaxIds: 'Demasiadas estaciones base seleccionadas. Se puede seleccionar un máximo de {cnt} estaciones base al agregar a un conjunto',
            removeFromSetMaxIds: 'Demasiadas estaciones base seleccionadas. Se puede seleccionar un máximo de {cnt} estaciones base al eliminar de un conjunto',
            radioSingleRoutesCount: 'Error al recuperar el número de rutas de radio únicas',
            radioAllRoutesCount: 'Error al recuperar la radio todas las rutas cuentan',
            retrieveFrequencies: 'Error al recuperar frecuencias',
            retrieveCities: 'Error al recuperar ciudades',
            retrieveTower: 'Error al recuperar estaciones base',
            csvParseError : "Se produjo un error al analizar el archivo CSV",
            validateErr:'Error al recuperar las estaciones base para la validación',
            colErr:'Nombre de columna inválido',
            allErr: "Todas las estaciones base en el archivo tenían errores, no se agregaron estaciones base.",
            retrieveRadio: 'Error al recuperar radios',
            retrieveById: 'Error al recuperar datos por ID',
            retrieveConfig: 'Error al recuperar configuraciones.',
            insufficientConfig: 'Historial de configuración insuficiente en las estaciones base seleccionadas',
            retrieveBaseStationChannelLoad: 'Error al recuperar la carga del canal de la estación base'
        },
        statuses: {
            ON: 'Encendido',
            OFF: 'Apagado',
            BATTERY: 'Batería baja',
            MAINTENANCE: 'Mantenimiento'
        },
        statusTypes: {
            NORMAL: 'Normal',
            NEVER_HEARD: 'Nunca oído',
            ON_BATTERY: 'En la batería'
        },
        enclosureTypes: {
            SingleTransceiverWoFusePanel: 'Single-Transceiver Indoor TGB without Fuse Panel',
            StandardOutdoor: 'Standard Outdoor TGB with Argus/Alpha Supply',
            SingleTransceiverWFusePanel: 'Single-Transceiver Indoor TGB with Fuse Panel',
            DualTransceiver: 'Dual-Transceiver Indoor TGB with Fuse Panel',
            TripleQuadTransceiver: 'Triple/Quad Transceiver Indoor TGB with Argus/Alpha Supply',
            ApcCustomMini: 'APC Custom Mini-TGB with NewMar Supply',
            MetroOutdoor: 'Metro Outdoor TGB with Lineage Supply',
            FlexnetRemotePortal: 'FlexNet Remote Portal (FRP)',
            M400B: 'M400B with Battery',
            S1600: 'S1600E',
            R100E: 'R100E',
            R100: 'R100'
        },
        demodulatorTypes: {
            INACTIVE: 'Inactive',
            NORMAL_ONLY: 'Normal (4.x)',
            BOOST_ONLY: 'Boost (5.x)',
            CANDI_ONLY: 'C&I (6.x)',
            PRIORITY_ONLY: 'Priority (7.x)',
            DD_ONLY: 'Double density 1/2FEC (8.x)',
            NORMAL_DD: 'Normal/Double density 1/2FEC (9.x)',
            CANDI_PRIORITY: 'C&I/Prority (10.x)',
            DD_1_2FEC_AND_3_4FEC: 'Double density 1/2FEC & 3/4FEC (11.x)',
            CANDI_OR_PRIORITY_2CH: 'C&I/Prority 2ch (12.x)',
            RSVD_10: 'Reserved10',
            RSVD_11: 'Reserved11',
            RSVD_12: 'Reserved12',
            RSVD_13: 'Reserved13',
            RSVD_14: 'Reserved14',
            UNKNOWN: 'Desconocido'
        },
        gpsFixes: {
            INVALID: 'Inválido',
            GPS_FIX: 'GPS Fijo',
            D_GPS_FIX: 'Arreglo diferencial de GPS'
        },
        transmitModes: {
            STRICT_SYNCHRONOUS: 'Estricta Sincrónico',
            SYNCHRONOUS: 'Sincrónico',
            SYNCHRONOUS_ABORTED: 'Sincrónico (Aborted)',
            DITHERED: 'Dithered',
            UNKNOWN: 'Desconocido'
        },
        softwareTypes: {
            LEGACY: 'Legado',
            UNIFIED: 'Unificado',
            UNIFIED_2: 'Unificado 2',
            UNIFIED_3: 'Unificado 3',
            null: 'No Establecido'
        },
        deploymentType:{
            QUEUED: "Puesto en cola",
            IN_PROGRESS: "En progreso",
            FAILED: "Fallido",
            COMPLETED: "Terminado",
            null: 'No Establecido'
        },
        temperatureComponents: {
            rf: 'Tarjeta de RF',
            pa: 'Amplificador de Poder',
            cpc0: 'Espacio de CPC 0',
            cpc1: 'Espacio de CPC 1',
            cpc2: 'Espacio de CPC 2',
            cpc3: 'Espacio de CPC 3',
            cpc4: 'Espacio de CPC 4',
            cpc5: 'Espacio de CPC 5',
            cpc6: 'Espacio de CPC 6',
            cpc7: 'Espacio de CPC 7',
            cpc8: 'Espacio de CPC 8',
            cpc9: 'Espacio de CPC 9'
        },
        powerMonitorTypes: {
            NONE: 'Sin monitor adjunto',
            DSPM: 'Monitor de Potencia DB Spectra',
            BIRD_7020: 'Bird Technologies modelo 7020',
            SPM: 'Monitor de Potencia Sensus',
            R100: 'Monitor de Potencia a bordo R100',
            PCC: 'Tarjeta de Control de Potencia Sensus',
            UNKNOWN: 'Desconocido'
        },
        ackTypes: {
            UNKNOWN: 'Desconocido',
            FNV1_BUDDY: 'FNv1 Compañera',
            FNV1_AC5: 'FNv1 AC5 Configuración y Enlace',
            FNV2_FT1_BUDDY: 'FNv2 FT1 (Eléctrica) Compañera',
            FNV2_FT4_BUDDY: 'FNv2 FT4 (Arqiva) Compañera',
            FNV2_FT9_BUDDY: 'FNv2 FT9 (Batería) Compañera',
            FNV2_FT9_AC5: 'FNv2 FT9 (Batería) AC5 Enlace y Análisis de Estación base'
        },
        ackStatus: {
            BuddyUnique: 'Únicos',
            BuddyDuplicate: 'Duplicados',
            TowerAckAgeExpired: 'Caducados',
            TowerAck: 'Transmitidos'
        },
        addBaseStationToSet: 'Agregar estación base a configurar',
        removeBaseStationFromSet: 'Quitar la estación base del conjunto',
        deleteBaseStation: 'Eliminar estación base',

        detailActionsSubTitle: 'Acciones de la estación base',
        addTowerToSetTitle: 'Agregar estación base a configurar',
        removeTowerFromSetTitle: 'Quitar la estación base del conjunto',

        channelPlanTransmit: "Transmitir canales en el plan de canales",
        channelPlanMissingTransmit: "Transmitir canales que no están en el plan de canales",
        channelPlanReceive: "Recibir canales en el plan de canales",
        channelPlanMissingReceive: "Recibir canales que no están en el plan de canales",

        networkPlanTransmit: "Transmitir canales en el plan de red",
        networkPlanMissingTransmit: "Canales de transmisión en el plan de red no configurados en la estación base",
        networkPlanNotPlannedTransmit: "Transmitir canales que no están en el plan de red",

        networkPlanReceive: "Recibir canales en el plan de red",
        networkPlanMissingReceive: "Recibir canales en el plan de red no configurado en la estación base",
        networkPlanNotPlannedReceive: "Recibir canales que no están en el plan de red",
        lastValidatedTransmit: "Informe de validación de la última transmisión",
        lastValidatedReceive: "Informe de validación de última recepción",
        resetBaselineUplinkSuccess: "Hora de inicio promedio del enlace ascendente de referencia establecida en {value}",
        resetBaselineConfirmMsg: "¿Está seguro de que desea restablecer la hora de inicio del cálculo del promedio de referencia?",
        resetBaselineConfirmTitle: "Confirmar restablecer hora de inicio",

        resetHysteresisForRadiosWithBestTower: "Restablecer la histéresis para las radios con la mejor estación base",
        resetHysteresisForRadiosWithBestTowerSuccess: 'Restablecimiento de histéresis para los puntos finales asociados',

        resetAnalysisDaysForBestTower: 'Restablecer días de análisis para los puntos finales asociados',
        resetAnalysisDaysForBestTowerSuccess: 'Días de análisis restablecidos para los puntos finales asociados',
        resetAnalysisDaysForBestTowerFailed: 'Error al restablecer los días de análisis para los puntos finales asociados',

        channelBalanceTower: 'Estación base de sintonización y equilibrio de canales',
        channelBalanceTowerRequestMade: 'Estación base de sintonización y balanceo de canales',
        tuningErrorMsg: 'Error de sintonización y equilibrio de canales en la estación base, consulte el registro'
    },
    modulation: {
        FSK_DISABLED: 'Discapacitada',
        FSK7: '7 FSK',
        FSK13: '13 FSK 1/2 FEC',
        FSK13_R34: '13 FSK 3/4 FEC',
        FSK13_REDUCED: '13 FSK Reducida',
        FSK13_EXTENDED: '13 FSK Extendida',
        FSK13_BOTH: '13 FSK Reducida + Extendida',
        FSK_CNI: 'C&I (7 FSK Half-Baud)',
        FSK_PRI: 'Priority (13 FSK Half-Baud)',
        FSK_BOOST: 'Boost',
        SFSK_BOOST: 'SFSK Boost',
        SFSK2: '2 SFSK',
        SFSK4: '4 SFSK',
        SFSK8: '8 SFSK',
        SFSK16: '16 SFSK',
        SFSK2_HB: '2 SFSK Half-Baud',
        SFSK4_HB: '4 SFSK Half-Baud',
        SFSK8_HB: '8 SFSK Half-Baud',
        SFSK16_HB: '16 SFSK Half-Baud',
        MPASS: 'mPass (5 kbps)',
        MPASS2: 'mPass2 (10 kbps)',
        M4PASS: 'm4Pass (10 kbps)',
        M4PASS2: 'm4Pass2 (20 kbps)',
        MPASS12K: 'mPass 12K',
        RADIO_SFSK_2: 'Radio 2 SFSK',
        RADIO_SFSK_4: 'Radio 4 SFSK',
        UNKNOWN: 'No Establecida',
        null: 'No Establecido'
    },
    fec: {
        NONE: 'Sin codificar',
        HALF: '½ Rate, K=3',
        THREE_QUARTER_K7: '¾ Rate, K=7',
        THREE_QUARTER_K4: '¾ Rate, K=4',
        UNKNOWN: 'No Establecida',
        null: 'No Establecido'
    },
    configStatus: {
        UNKNOWN: 'Desconocida',
        CURRENT: 'De hoy en día',
        PENDING: 'Pendiente',
        QUEUED: 'Puesto en cola',
        ERROR: 'Hay Error',
        CANCELLED: "Cancelado",
        IN_PROGRESS: 'En progreso',

    },
    configCommandStatus: {
        UNKNOWN: 'Desconocida',
        QUEUED: 'Puesto en cola',
        IN_PROGRESS: 'En progreso',
        SUCCESS: 'Éxito',
        FAILED: 'Fallido',
        CANCELLED: "Cancelado",
    },
    deploymentStatus: {
        CURRENT: 'De hoy en día',
        CURRENT_WITH_WARNINGS: 'Actual con advertencias',
        NOT_DEPLOYED: 'No Desplegada',
        ERROR: 'Hay Error',
        OUT_OF_DATE: 'Fuera de plazo',
        QUEUED: 'Puesto en cola',
        DEPLOYING: 'Implementando'
    },
    plannedStatus: {
        PLANNED: 'Planeado',
        NOT_PLANNED: 'No estaba planeado'
    },
    securityConfigStatus: {
        COMPLETED: 'Completado',
        FAILED: 'Fallido',
        QUEUED: 'En cola',
        IN_PROGRESS: 'En Progreso'
    }
}
